export const getOption = (arg) => {
  if (arg.length <= 0) {
    return false;
  } else if (arg[0] === "-") {
    return arg.slice(1, arg.length);
  } else {
    return false;
  }
};

export const parseOptions = (segments) => {
  let options = [];
  let args = [];
  for (let seg of segments) {
    let opt = getOption(seg);
    if (opt) options.push(opt);
    else args.push(seg);
  }
  return {
    options,
    args,
  };
};

export const createError = (errMsg, multi = false) => {
  return { error: true, errMsg, multi };
};

export const createSuccess = (msg, multi = false) => {
  return { error: false, msg, multi };
};
